<script lang="ts">
	import { goto } from '$app/navigation';
	import { FlowTwoFactorAuthSetup, IconButton, PasswordChangeModal, contextMenuState, login } from '@enzianweb/shared';
	import { _ } from 'svelte-i18n';

	let showPasswordResetModal: boolean = $state(false);
	let showTwoFactorAuth = $state(false);

	async function openContextMenu(e: MouseEvent) {
		e.stopPropagation();

		const menuItems = [
			{
				title: $_('header.login_context.lbl_job_log'),
				callbackFunction: () => {
					goto('/queue-tasks');
				}
			},
			{
				title: $_('header.login_context.lbl_password_change'),
				callbackFunction: () => {
					showPasswordResetModal = true;
				}
			},
			{
				title: $_('header.login_context.lbl_two_factor_auth'),
				callbackFunction: () => {
					//Show the 2FA setup steps
					showTwoFactorAuth = true;
				}
			},
			{
				title: $_('header.login_context.lbl_log_out'),
				callbackFunction: () => {
					logoutFromServer();
				}
			}
		];

		$contextMenuState = {
			x: e.clientX,
			y: e.clientY,
			menuItems: menuItems
		};
	}

	/**
	 * Send a logout request to the api, so that the cookie will be removed.
	 */
	async function logoutFromServer() {
		await login.logout();
	}
</script>

<div class="z-10">
	<IconButton
		primary={true}
		hoverText={$_('navigation.bt_user')}
		onClick={openContextMenu}
		text={$login?.loginName.substring(0, 2)}
	/>
</div>

{#if showPasswordResetModal}
	<PasswordChangeModal
		loginId={$login?.id || 0}
		onModalClose={() => {
			showPasswordResetModal = false;
		}}
	/>
{/if}

{#if showTwoFactorAuth}
	<FlowTwoFactorAuthSetup
		onModalClose={() => {
			showTwoFactorAuth = false;
		}}
		verifyFunction={login.verifyTwoFactorAuthCodeForSetup}
		deactivateFunction={login.removeToFactorAuth}
		targetLoginId={$login!.id}
		twoFactoryActive={$login!.isTwoFactorAuth}
	/>
{/if}
